exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\r\n    width: 150px;\r\n    background-color: gainsboro;\r\n    border-style: solid;\r\n    border-color: black;\r\n    border-width: 1px;\r\n    border-radius: 2px;\r\n    box-shadow: 4px 4px 2px darkgrey;\r\n    padding: 0;\r\n}\r\n\r\ntable {\r\n    table-layout: fixed;\r\n    border-spacing: 0px;\r\n    border-collapse: separate;\r\n    font-weight: bold;\r\n    font-size: 13px;\r\n    width: 100%;\r\n}\r\n\r\ntbody {\r\n    display: block;\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n}\r\n\r\ntd {\r\n    text-align: left;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n}\r\n\r\ntr {\r\n    width: 100%;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: gainsboro;\r\n    height: 25px;\r\n}\r\n\r\ntr:hover {\r\n    background-color: lightsteelblue;\r\n    border-color: steelblue;\r\n    border-style: double;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ContextMenu/contextMenu.component.css
// module id = 439
// module chunks = 1